import React from 'react'
import { Row, Col } from 'reactstrap'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'
import { MdEventNote } from 'react-icons/md'
import { BsFlag } from 'react-icons/bs'
import { SiCircle } from 'react-icons/si'
import { prop } from 'ramda'
import { Paragraph, ContainerLg } from '../../GlobalStylesNew'
import { Benefit } from './Benefit'

export const DescriptionSection = styled.div`
  padding: 150px 0 150px;
  color: #00234b;
`

export const Subtitle = styled.h5`
  line-height: 27px;
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 20px;
  @media (min-width: 992px) {
    margin-right: 50px;
  }
`

export const Title = styled.p`
  font-size: 60px;
  font-weight: Bold;
  font-family: 'Source Serif Pro', sans-serif;
`

const NoteIcon = styled(MdEventNote)`
  color: #836f50;
  margin-top: 10px;
`

const FlagIcon = styled(BsFlag)`
  color: #836f50;
  margin-top: 10px;
`

const CircleLoopedIcon = styled(SiCircle)`
  color: #836f50;
  margin-top: 10px;
`

const Testimonials = styled.div`
  background: rgba(131, 111, 80, 0.24);
  padding: 30px;
`

export const ImgWrapper = styled.div`
  float: left;
  margin-right: 10px;
`

const benefits = [
  {
    icon: <NoteIcon size={'24px'} />,
    title: 'Teaching & Coaching',
    text:
      'Provides coaches with tools to better teach and market their services to current and perspective clients.'
  },
  {
    icon: <FlagIcon size={'24px'} />,
    title: 'Golf Operations',
    text:
      'Driving more play. People who play better golf, play more golf. And this comes with an increased spend in ' +
      'all areas of the facility.'
  },
  {
    icon: <CircleLoopedIcon size={'24px'} />,
    title: 'Executive Management',
    text:
      'Selling and retaining customers. Great coaching will retain members who develop meaningful realtionships with their coach.'
  }
]

export const OurBenefits = () => {
  return (
    <DescriptionSection>
      <ContainerLg>
        <Row>
          <Col xs='12'>
            <Title>Our Benefits</Title>
          </Col>
        </Row>
        <Row>
          <Col xs='12' lg='8'>
            <Subtitle>
              The American Development Model Certificate and PGA Coach will
              allow PGA Professionals to evolve and adapt to the changes in the
              game and to a new generation of players.
            </Subtitle>
            <Subtitle>
              Start your journey today with a PGA Coach education; access all
              the benefits of PGA Coach and lay the foundation to grow sport
              participation for a lifetime.
            </Subtitle>

            {benefits.map(benefit => (
              <Benefit
                icon={benefit.icon}
                title={benefit.title}
                text={benefit.text}
              />
            ))}
          </Col>
          <Col xs='12' lg='4'>
            <Testimonials>
              <Paragraph>
                “The PGA Coach Platform changed the way I run my business. It’s
                allowed me to free up my time to focus on what’s important. My
                students.”
              </Paragraph>
              <ImgWrapper>
                <StaticQuery
                  query={graphql`
                    query {
                      Author: file(relativePath: { eq: "Home/author1.png" }) {
                        ...optimizedImage
                        childImageSharp {
                          fixed(width: 50, height: 50) {
                            ...GatsbyImageSharpFixed
                          }
                        }
                      }
                    }
                  `}
                  render={data => (
                    <>
                      {prop('Author', data) ? (
                        <Img fixed={data.Author.childImageSharp.fixed} />
                      ) : null}
                    </>
                  )}
                />
              </ImgWrapper>
              <Paragraph>
                {' '}
                <b>
                  {' '}
                  Jex H. Wilson
                  <br />
                  PGA Master Professional
                </b>
              </Paragraph>
            </Testimonials>
          </Col>
        </Row>
      </ContainerLg>
    </DescriptionSection>
  )
}

export default OurBenefits
